/**
 * Clinic portal order sheet (用紙発注) API service.
 */

import { apiClient } from '@/shared/lib/axios';
import { clinicApiPath } from '@/shared/lib/apiPath';
import { SERVICE_TYPE_A2, SERVICE_TYPE_R2 } from '@/constants/serviceType';
import type { OrderSheetInitData, OrderSheetSubmitPayload, ApiResponse } from '@/pages/main/orderSheet/types';

/**
 * Get order form init data: rezept_sheets and delivery_fee.
 * @param serviceType - A2 or R2 (default from localStorage or 'R2')
 */
export async function getOrderSheetInit(
  siteType: string,
  clinicNumber: string,
  serviceType?: string
): Promise<ApiResponse<OrderSheetInitData>> {
  const type = serviceType || localStorage.getItem('service_type') || SERVICE_TYPE_R2;
  const effectiveType = type === SERVICE_TYPE_A2 ? SERVICE_TYPE_A2 : SERVICE_TYPE_R2;
  const response = await apiClient.get<ApiResponse<OrderSheetInitData>>(
    clinicApiPath(siteType, clinicNumber, '/order-sheets/init'),
    {
      params: { service_type: effectiveType },
      headers: { 'X-Service-Type': effectiveType },
    }
  );
  return response.data;
}

/**
 * Submit order (用紙発注).
 */
export async function submitOrderSheet(
  siteType: string,
  clinicNumber: string,
  payload: OrderSheetSubmitPayload
): Promise<ApiResponse<{ order_rezept_sheet_id: number }>> {
  const response = await apiClient.post<ApiResponse<{ order_rezept_sheet_id: number }>>(
    clinicApiPath(siteType, clinicNumber, '/order-sheets'),
    payload
  );
  return response.data;
}
